import { Col, Form, FormInstance, Row, Typography } from 'antd';
import { observer } from 'mobx-react';
import { SharedForm } from './SharedForm';

const { Text } = Typography;

interface IProps {
  form: FormInstance<any>;
  onCancel: () => void;
  onSubmit: (values: any) => Promise<void>;
}

export const ReadyForPickupForm: React.FC<IProps> = observer(({ form, onCancel, onSubmit }) => {
  return (
    <SharedForm
      initialValues={{ sendPush: true }}
      form={form}
      onCancel={onCancel}
      onFinish={onSubmit}
      submitTitle="Yes, inform"
      cancelTitle="Don't inform"
    >
      <Row>
        <Col>
          <Form.Item>
            <Text strong>Inform the customer that their vehicle is ready for pick up?</Text>
          </Form.Item>
        </Col>
      </Row>
    </SharedForm>
  );
});
